import { memo } from 'react';
import PropTypes from 'prop-types';

import { ListItemButton } from '@mui/material';

const MListItemButton = memo(({ children, href = '', isClickable = false }) => {
  if (!isClickable) {
    return children;
  }

  return (
    <ListItemButton component="a" href={href}>
      {children}
    </ListItemButton>
  );
});

MListItemButton.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  isClickable: PropTypes.bool
};

export default MListItemButton;
